var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"typeTransport-icon",attrs:{"src":_vm.setClassTypeTransport(_vm.data)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }